import React from 'react';
import Maptable from './components/viewmapform';
import { withTranslation } from 'react-i18next';

const ViewMapData = () => {

  var van_details = JSON.parse(localStorage.getItem("van_group"));
  
  return(
  <div style={{width:"100%",margin:"0px",padding:"0px"}}>
    <div ><Maptable van_data={van_details}/></div>
      
  </div>

  )
  };

export default withTranslation('common')(ViewMapData);
